import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

//브라우저 지원 여부 확인
export const checkBrowser = () => {
  const [isSupported, setIsSupported] = useState(true);

  useEffect(() => {
    const { userAgent } = navigator;
    const isChromium = userAgent.includes('Chrome');
    const isSafari = userAgent.includes('Safari');
    setIsSupported(isChromium || isSafari);
  }, []);

  return isSupported;
};

//사용자 선호 언어로 변경
export const initUserLanguage = () => {
  const { i18n } = useTranslation();
  const { language, changeLanguage } = i18n;

  useEffect(() => {
    const { language: curLang } = navigator;
    language !== curLang && changeLanguage(curLang);
  }, []);
};
